import { topicgroupsApi } from "api/topicgroups/topicgroupsApi";
import { TopicAppearanceApi } from "api/topics/topicsApi";
import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";

export const useTopicGroupAppearances = (topicId: number) => {
  const queryClient = useQueryClient();
  const { isLoading, data } = useQuery({
    queryKey: QUERIES_KEYS.TOPIC_GROUP_APPEARANCES(topicId),
    queryFn: () => topicgroupsApi.featchAppearances(topicId),
  });
  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.TOPIC_GROUP_APPEARANCES(topicId),
    });
  };

  return { invalidate, isLoading, appearances: data?.data ?? ({} as TopicAppearanceApi) };
};
